import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrandMark from './BrandMark';
import { useLang } from '../i18n/context';
import './GlobalFooter.css';

function GlobalFooter() {
  const navigate = useNavigate();
  const { lang, t } = useLang();

  const copyWechat = () => {
    navigator.clipboard.writeText('admiraltyz');
    const tip = document.getElementById('wechat-copy-tip');
    if (tip) {
      tip.textContent = lang === 'zh' ? '已复制' : 'Copied';
      setTimeout(() => { tip.textContent = t('home.wechatTip'); }, 1500);
    }
  };

  return (
    <footer className="gf">
      <div className="gf-inner">
        {/* 第一行：品牌信息横排 */}
        <div className="gf-brand-row">
          <div className="gf-brand-left">
            <BrandMark className="gf-logo-img" alt="GHOST" />
            <span className="gf-logo-text">游领社区</span>
            <span className="gf-slogan">{t('home.footerSlogan')}</span>
          </div>
          <div className="gf-brand-right">
            <div className="gf-social-icon wechat" style={{ cursor: 'pointer' }} onClick={copyWechat}>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05a6.42 6.42 0 01-.246-1.79c0-3.558 3.39-6.451 7.585-6.451.258 0 .509.025.764.042C16.672 4.627 13.034 2.188 8.691 2.188zm-2.35 4.477a.97.97 0 110 1.94.97.97 0 010-1.94zm5.321 0a.97.97 0 110 1.94.97.97 0 010-1.94zM23.997 15.39c0-3.248-3.236-5.882-7.229-5.882-3.992 0-7.228 2.634-7.228 5.882 0 3.248 3.236 5.882 7.228 5.882.79 0 1.55-.103 2.275-.289a.69.69 0 01.574.078l1.525.89a.26.26 0 00.133.044c.13 0 .232-.105.232-.236 0-.058-.023-.114-.039-.17l-.312-1.186a.472.472 0 01.171-.532c1.462-1.075 2.39-2.648 2.39-4.39zm-9.725-1.357a.78.78 0 110 1.56.78.78 0 010-1.56zm4.993 0a.78.78 0 110 1.56.78.78 0 010-1.56z"/></svg>
              <span id="wechat-copy-tip" className="gf-social-tooltip">{t('home.wechatTip')}</span>
            </div>
          </div>
        </div>

        {/* 第二行：三列链接横排 */}
        <div className="gf-links-row">
          <div className="gf-col">
            <h4 className="gf-col-title">{t('home.footerGrowth')}</h4>
            <button className="gf-link" onClick={() => navigate('/docs')}>{t('home.footerArticles')}</button>
            <button className="gf-link" onClick={() => navigate('/docs')}>{t('home.footerBooklist')}</button>
            <button className="gf-link" onClick={() => navigate('/register')}>{t('home.footerInvite')}</button>
          </div>
          <div className="gf-col">
            <h4 className="gf-col-title">{t('home.footerPro')}</h4>
            <button className="gf-link" onClick={() => navigate('/pattern-match')}>{t('home.footerKlineTool')}</button>
            <button className="gf-link" onClick={() => navigate('/?mode=pro')}>{t('home.footerDataAnalysis')}</button>
            <span className="gf-link gf-link--soon">{t('home.footerFinCalendar')}</span>
          </div>
          <div className="gf-col">
            <h4 className="gf-col-title">{t('home.footerFollow')}</h4>
            <button className="gf-link" onClick={copyWechat}>{t('home.footerWechat')}</button>
          </div>
        </div>
      </div>
      <div className="gf-bottom"><span>{t('home.copyright')}</span></div>
    </footer>
  );
}

export default GlobalFooter;
